SupportAppRouter = require('./AppRouter')
SupportViewManagerFactoryView = require('./view_manager/view_manager_factory')
SupportUtilsHelper = require('./helpers/utils')
SharedUtilsHelper = require('../../shared/frontend/helpers/utils')
SharedFeatureFlagModel = require('../../shared/frontend/models/feature_flag_model')

Date.now = Date.now || -> +new Date

unless (typeof String.prototype.trim is 'function')
  String.prototype.trim = () ->
    return this.replace(/^\s+|\s+$/g, '')

Support =
  createSupportNameSpace: ->
    window.Groupon ?= {}
    window.Groupon.Support ?= {}
    Groupon.Support.Email = {}
    _.extend window, SupportUtilsHelper
    _.extend window, SharedUtilsHelper

  initializeConstants: ->
    Groupon.Support.FeatureFlagModel = new SharedFeatureFlagModel()
    Groupon.Support.DELAY_TIMES =
      flash: 2500

  constructViewManager:  ->
    Groupon.Support.HelpWizardViewManager = SupportViewManagerFactoryView.getViewManager()
    Groupon.Support.HelpWizardViewManager.render()

$(document).ready ->
  Support.createSupportNameSpace()
  redirectToFaqHack()
  Support.initializeConstants()
  activateieHacks()
  Support.constructViewManager()
  Groupon.Support.Router = new SupportAppRouter()
  Backbone.history.start({root: window.SUPPORTBASEURL})

  $('.help-wizard-menu').on('click', () ->
    redirectToHelpWizard()
    return false
  )
  $('.faqs-menu').on('click', ->
    redirectToFaq()
    return false
  )
  Groupon.Performance.pageReady()
  window.Groupon.ready = true
